import { HttpBackend, HttpClient, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { IAppDictionary, IPaginationParams } from '@interfaces';
import { ApiResponse } from '@shared';
import { Observable } from 'rxjs';
import { TokenService } from './token.service';
import { CookieService } from 'ngx-cookie-service';

@Injectable({
  providedIn: 'root',
})
export class AppDictionaryService {
  private readonly apiUrl = `${environment.apiUrl}/v1/admin/app-dictionary`;
  private httpClient: HttpClient;
  constructor(
    private httpBackend: HttpBackend,
    public tokenService: TokenService,
    private cookiesService: CookieService,
  ) {
    this.httpClient = new HttpClient(httpBackend);
  }

  private getHeaders(): HttpHeaders {
    const token = this.tokenService.getTokens()?.accessToken || '';
    return new HttpHeaders({
      Authorization: token ? `Bearer ${token}` : '',
      language: this.cookiesService.get(environment.languageCookieKey) || 'he',
    });
  }

  private createHttpParams(filterData: IPaginationParams): HttpParams {
    let params = new HttpParams()
      .set('pageNum', filterData.pageNum.toString())
      .set('pageLimit', filterData.pageLimit.toString())
      .set('search', filterData.search || '')
      .set('sortField', filterData.sortField || '')
      .set('sortOrder', filterData.sortOrder?.toString() || '');
    filterData?.columnFilters?.forEach((ele) => {
      const [key, value] = Object.entries(ele)[0];
      params = params.set(key, value?.$regex);
    });
    return params;
  }

  getAllAppDictionary(filterData: IPaginationParams) {
    const params = this.createHttpParams(filterData);
    const headers = this.getHeaders();
    return this.httpClient.get<ApiResponse>(this.apiUrl, { params, headers });
  }

  addAppDictionary(body: IAppDictionary) {
    const headers = this.getHeaders();
    return this.httpClient.post(this.apiUrl, body, { headers });
  }

  exportAppDictionary(
    filterData: IPaginationParams,
    exportType: string,
    responseType: string,
  ): Observable<HttpResponse<Blob>> {
    const params = this.createHttpParams(filterData);
    const headers = this.getHeaders();
    const options = {
      observe: 'response' as 'body',
      responseType: 'blob' as 'json',
      params,
      headers,
    };
    return this.httpClient.post<HttpResponse<Blob>>(`${this.apiUrl}/export`, { exportType, responseType }, options);
  }
}
